import { startCase } from "lodash";

export const PAGE_SIZE = 10;

export const TIMEOUT_MS = 10000;

export const SENTIMENT = {
  POSITIVE: "positive",
  NEUTRAL: "neutral",
  NEGATIVE: "negative",
};

export const STATUS = {
  PREDICTED: "predicted",
  PROCESSED: "processed",
  ERRORED: "errored",
};

export const SENTIMENT_OPTIONS = Object.values(SENTIMENT).map((value) => ({
  label: startCase(value),
  value,
}));

export const PROFANITY_OPTIONS = [
  {
    label: "Yes",
    value: true,
  },
  { label: "No", value: false },
];
